module.exports = __webpack_public_path__ + "img/log1.07a67106.png";